import React, { useState, useEffect , useCOntext } from 'react';

import { useHistory } from 'react-router-dom';

import { auth } from '../components/firebase';


const AuthContext = React.createContext();

export const useAuth = () => React.useContext(AuthContext);

export const AuthProvider = ({ children }) => {

    const[loading , setLoading] = useState(true);
    const[user , setUser ] = useState(null);
    const history = useHistory();

    useEffect(() => {

        auth.onAuthStateChanged( (user) => {

            setUser(user);
            setLoading(false);
            if(user) history.push('/chats')
        })
       
    }, [user, history])

    const value = {user};

    return (
        <AuthContext.Provider value = { value }>

            {!loading && children}

        </AuthContext.Provider>

        )
    
};

